import {useState, useEffect } from 'react'
import { generalGetRequest } from '../../functions/api/general'
import moment from 'moment'
import { matchObjectId } from '../../utils'
import { useSelector } from 'react-redux'
import { MONTH_REPORT, YEAR_REPORT, WEEK_REPORT } from '../../constants'
import { useLocation } from 'react-router'

export const useChartReport = (reportType, departmentId, weeklyReport ) => {
  const [data, setData] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [startDate, setStartDate] = useState('')

  const increaseStartDateHandler = () => {
    const newStartDate = moment(startDate).add(1, reportType).startOf(reportType).toDate()
    setStartDate(newStartDate)
  }

  const decreaseStartDateHandler = () => {
    const newStartDate = moment(startDate).subtract(1, reportType).startOf(reportType).toDate()
    setStartDate(newStartDate)
  }

  useEffect(()=>{
    const newStartDate = moment().startOf(reportType).toDate()
    setStartDate(newStartDate)
  },[reportType, weeklyReport])

  
  useEffect(()=>{
    const getData = async () => {
      setIsLoading(true)
      const depId = matchObjectId(departmentId)
      const res = await generalGetRequest(`/system/reports/chart?type=${reportType}&start_date=${startDate}&department_id=${depId}&weeklyReport=${weeklyReport}`)
      if(res.ok && res.result) setData(res.result)
      setIsLoading(false)
    }
    startDate && getData()
  },[departmentId, startDate])

  return {
    charts: data, 
    isLoading, 
    startDate, 
    increaseStartDateHandler, 
    decreaseStartDateHandler
  }
}

export const useDepartmentsOptions = () => {
  const departments = useSelector(state => state.login.departments)
  
  const departmentsOptions = departments.map(i => ({_id: i._id, value: i.name}))
  return departmentsOptions
}

export const useReportType = () => {
  const {pathname} = useLocation()
  let reportType = null
  if(pathname.includes(YEAR_REPORT)){
    reportType = YEAR_REPORT
  } else if(pathname.includes(WEEK_REPORT)){
    reportType = YEAR_REPORT
  } else{
    reportType = MONTH_REPORT
  }
  return reportType
}

export const useWeekReportType = () => {
  const {pathname} = useLocation()
  return pathname.includes(WEEK_REPORT)
}